// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"0e748fa9","703":"72150da4","787":"ce0f9895"}[chunkId] + ".chunk.js";
};